import { defineStore } from 'pinia';
import piniaPersistConfig from '../persist';
export const loginData = defineStore({
  id: 'loginData',
  state: () => {
    return {
      token: '',
      mobileNo: '',
      orderList:[],
      id:''
    };
  },
  actions: {
    updateToken(str: string): void {
      this.token = str;
    },
    updateMobileNo(data: any) {
      this.mobileNo = data;
    },
    updateOrderList(data: any) {
      this.orderList = data;
    },
    updateID(data: any) {
      this.id = data;
    },
    reset() {
      this.token = '';
      this.mobileNo = '';
      this.orderList = []
      this.id = ''
    },
    
  },
  // 注意defineStore的第三个参数可以传入插件配置，根据配置只持久化lastName
  persist: piniaPersistConfig('loginData', true)
});
